<template>
  <section class="section section--gamehot">
    <img v-if="$isEnableThemeNoel()" class="event-leaf top-mb left bottom width-2" src="/assets/img/event/noel/home/leaf-left-2.svg" alt="leaf">
    <b-container>
      <div class="section__title text-center">
        <div class="start-title">
          <img src="/assets/img/line-star.png" alt="start" loading="lazy"/>
        </div>
        <div class="heading h2"><span>{{ title }}</span></div>
      </div>
      <div class="wrap-game">
        <b-row class="list-game" v-if="items.length > 0">
          <game-item v-for="(g, inx) in items" :key="inx" :item="g" />
        </b-row>
      </div>
    </b-container>
    <div v-if="seeMoreLink.length > 0" class="section-readmore flex-box just-center">
      <n-link :to="seeMoreLink">XEM THÊM <i class="las la-arrow-right"></i></n-link>
    </div>
    <img v-if="$isEnableThemeNoel()" class="event-leaf top-mb width-1" src="/assets/img/event/noel/home/leaf-right-2.svg" alt="leaf">
  </section>
</template>
<script>
import gameItem from '../games/gameItem.vue';

export default {
    components: {
        gameItem
    },
    props: {
        items: {
            type: Array,
            default: () => []
        },
        title: {
            type: String,
            default: () => ''
        },
        seeMoreLink: {
            type: String,
            default: () => ''
        }

    },
    methods: {
        moveTo(item) {
            if (item.playGame !== null) {
                this.$playGame(item.playGame);
            } else if (item.newtab && this.$isMobile()) {
                window.open(item.link, '_blank');
            } else {
                this.$router.push(item.link);
            }
        }
    }
};
</script>
